import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalFocusService } from './core/utils/modal-focus.service';
import { PageAnalyticsService } from './core/utils/page-analytics.service';
import { ToastComponent } from './shared/toasts/toast/toast.component';
import { AlertComponent } from './shared/alerts/alert/alert.component';
import { AlertInputComponent } from './shared/alerts/alert-input/alert-input.component';
import { LoadingComponent } from './shared/loadings/loading/loading.component';
import { BuyPlanModalComponent } from './modals/buy-plan-modal/buy-plan-modal.component';
import { InactivityModalComponent } from './shared/inactivity-modal/inactivity-modal.component';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	imports: [
		RouterOutlet,
		ToastComponent,
		AlertComponent,
		AlertInputComponent,
		LoadingComponent,
		BuyPlanModalComponent,
		InactivityModalComponent
	]
})
export class AppComponent {
	translate = inject(TranslateService);

	title = 'zeyo-frontend';

	constructor() {
		inject(ModalFocusService);
		inject(PageAnalyticsService);
		const translate = this.translate;

		const langs = ['en', 'es', 'ca'];
		translate.addLangs(langs);
		translate.setDefaultLang('en');
		const lang = translate.getBrowserLang();
		for (const iterator of langs) {
			if (iterator === lang) translate.use(iterator);
		}
	}
}
